// extracted by mini-css-extract-plugin
export default {"legalPage":"Legal_legalPage__X3x7A","container":"Legal_container__7P9Oa","lastUpdated":"Legal_lastUpdated__8BR9N","content":"Legal_content__lC8fs"};